/** @format */

import React from 'react';
import { SuitableForCouplesWrapper, TooltipGroup, CouplePrice, TooltipTitle } from './SuitableForCouples.style';
import { FormattedMessage } from 'gatsby-plugin-intl';
import { Icon } from '@/components/ui/Icon';
import TooltipIcon from '@/assets/icons/tooltip-icon.svg';
import { useAppTranslation } from '@/i18n/declarations';
import { Tooltip } from 'react-tooltip';
import { TTranslation } from '@/i18n/createProvider';

type SuitableForCouplesProps = {
  hasPromo?: boolean;
};

const SuitableForCouples: React.FC<SuitableForCouplesProps> = ({ hasPromo = true }) => {
  const { t } = useAppTranslation();
  return (
    <SuitableForCouplesWrapper $hasPromo={hasPromo}>
      <TooltipGroup>
        <TooltipTitle $hasPromo={hasPromo}>
          <FormattedMessage id="pdp.suitable_for_couples_title" />
        </TooltipTitle>
        <a
          data-tooltip-id="suitable-for-couples-tooltip"
          data-tooltip-content={t('pdp.suitable_for_couples_description' as TTranslation)}
        >
          <Icon icon={TooltipIcon} width={16} height={16} />
        </a>
        <Tooltip id="suitable-for-couples-tooltip" className="default-tooltip" />
      </TooltipGroup>
      <CouplePrice $hasPromo={hasPromo}>+ 200€</CouplePrice>
    </SuitableForCouplesWrapper>
  );
};

export default SuitableForCouples;
